import { createLogger } from "@/domain/logging";

export const scaledRenderLog = createLogger("GENERATE");
